/**
 * Form telefon alanı için ülke kodu listesi.
 * Builder (customer-panel) ve public form (supForm) ortak içerik kullanır.
 */

export const DEFAULT_COUNTRY_ISO = "TR";

/**
 * iso2 kodundan bayrak emoji üretir (regional indicator symbols).
 * @param {string} iso2
 * @returns {string}
 */
export function countryFlag(iso2) {
    if (!iso2) return "";
    const code = iso2.toUpperCase();
    return code.replace(/./g, function (c) {
        return String.fromCodePoint(127397 + c.charCodeAt(0));
    });
}

/**
 * Yaygın ~50 ülke. dialCode "+" olmadan saklanır.
 */
export const COUNTRY_CODES = [
    { iso2: "TR", name: "Türkiye", dialCode: "90" },
    { iso2: "US", name: "United States", dialCode: "1" },
    { iso2: "GB", name: "United Kingdom", dialCode: "44" },
    { iso2: "DE", name: "Deutschland", dialCode: "49" },
    { iso2: "FR", name: "France", dialCode: "33" },
    { iso2: "IT", name: "Italia", dialCode: "39" },
    { iso2: "ES", name: "España", dialCode: "34" },
    { iso2: "NL", name: "Nederland", dialCode: "31" },
    { iso2: "BE", name: "België", dialCode: "32" },
    { iso2: "CH", name: "Schweiz", dialCode: "41" },
    { iso2: "AT", name: "Österreich", dialCode: "43" },
    { iso2: "SE", name: "Sverige", dialCode: "46" },
    { iso2: "NO", name: "Norge", dialCode: "47" },
    { iso2: "DK", name: "Danmark", dialCode: "45" },
    { iso2: "FI", name: "Suomi", dialCode: "358" },
    { iso2: "PL", name: "Polska", dialCode: "48" },
    { iso2: "RU", name: "Россия", dialCode: "7" },
    { iso2: "UA", name: "Україна", dialCode: "380" },
    { iso2: "GR", name: "Ελλάδα", dialCode: "30" },
    { iso2: "PT", name: "Portugal", dialCode: "351" },
    { iso2: "IE", name: "Ireland", dialCode: "353" },
    { iso2: "CZ", name: "Česko", dialCode: "420" },
    { iso2: "RO", name: "România", dialCode: "40" },
    { iso2: "BG", name: "България", dialCode: "359" },
    { iso2: "HR", name: "Hrvatska", dialCode: "385" },
    { iso2: "RS", name: "Srbija", dialCode: "381" },
    { iso2: "AZ", name: "Azərbaycan", dialCode: "994" },
    { iso2: "UZ", name: "Oʻzbekiston", dialCode: "998" },
    { iso2: "KZ", name: "Қазақстан", dialCode: "7" },
    { iso2: "KG", name: "Кыргызстан", dialCode: "996" },
    { iso2: "TM", name: "Türkmenistan", dialCode: "993" },
    { iso2: "AE", name: "United Arab Emirates", dialCode: "971" },
    { iso2: "SA", name: "Saudi Arabia", dialCode: "966" },
    { iso2: "QA", name: "Qatar", dialCode: "974" },
    { iso2: "KW", name: "Kuwait", dialCode: "965" },
    { iso2: "BH", name: "Bahrain", dialCode: "973" },
    { iso2: "OM", name: "Oman", dialCode: "968" },
    { iso2: "JO", name: "Jordan", dialCode: "962" },
    { iso2: "LB", name: "Lebanon", dialCode: "961" },
    { iso2: "IQ", name: "Iraq", dialCode: "964" },
    { iso2: "IR", name: "Iran", dialCode: "98" },
    { iso2: "EG", name: "Egypt", dialCode: "20" },
    { iso2: "MA", name: "Morocco", dialCode: "212" },
    { iso2: "DZ", name: "Algeria", dialCode: "213" },
    { iso2: "TN", name: "Tunisia", dialCode: "216" },
    { iso2: "LY", name: "Libya", dialCode: "218" },
    { iso2: "CN", name: "China", dialCode: "86" },
    { iso2: "JP", name: "Japan", dialCode: "81" },
    { iso2: "KR", name: "South Korea", dialCode: "82" },
    { iso2: "IN", name: "India", dialCode: "91" },
    { iso2: "PK", name: "Pakistan", dialCode: "92" },
    { iso2: "ID", name: "Indonesia", dialCode: "62" },
    { iso2: "MY", name: "Malaysia", dialCode: "60" },
    { iso2: "SG", name: "Singapore", dialCode: "65" },
    { iso2: "TH", name: "Thailand", dialCode: "66" },
    { iso2: "CA", name: "Canada", dialCode: "1" },
    { iso2: "MX", name: "México", dialCode: "52" },
    { iso2: "BR", name: "Brasil", dialCode: "55" },
    { iso2: "AU", name: "Australia", dialCode: "61" },
    { iso2: "NZ", name: "New Zealand", dialCode: "64" },
    { iso2: "NG", name: "Nigeria", dialCode: "234" },
    { iso2: "ZA", name: "South Africa", dialCode: "27" },
];

const COUNTRY_BY_ISO = COUNTRY_CODES.reduce(function (acc, c) {
    acc[c.iso2] = c;
    return acc;
}, {});

/**
 * @param {string} iso2
 * @returns {Object|null}
 */
export function getCountryByIso(iso2) {
    if (!iso2) return null;
    return COUNTRY_BY_ISO[iso2.toUpperCase()] || null;
}

/**
 * @param {string} iso2
 * @returns {string} "+90" formatında dial code; bulunamazsa "+90" (TR) döner
 */
export function getDialCode(iso2) {
    const c = getCountryByIso(iso2);
    return c ? "+" + c.dialCode : "+90";
}
